import { buildComponent } from '#components'
import { z } from 'zod'
import ProductQuickAddVue from './ProductQuickAdd.vue'

import './product-quick-add.css'

const ProductQuickAddPropsSchema = z.object({
  handle: z.string()
})

export type ProductQuickAddProps = z.infer<typeof ProductQuickAddPropsSchema>

const ProductQuickAdd = buildComponent({
  name: 'product-quick-add',
  propsSchema: ProductQuickAddPropsSchema,
  vueComponent: ProductQuickAddVue
}) as ReturnType<typeof buildComponent>

declare global {
  interface HTMLElementTagNameMap {
    'product-quick-add': typeof ProductQuickAdd
  }
}
